"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var flags = function flags(flagNames) {
    return function (flags) {
        return Object.assign({}, flags, {
            matches: function matches(flag, match) {
                return (flag & flags[match]) == flags[match];
            }
        });
    }(flagNames.map(function (flag, index) {
        return _defineProperty({}, flag, Math.pow(2, index));
    }).reduce(function (combined, cur) {
        return Object.assign({}, combined, cur);
    }, { NONE: 0 }));
};

exports.default = flags;